import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getMe } from '../../services/authService';

const PrivateRoute = ({ children }) => {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        await getMe();
        if (isMounted) setAllowed(true);
      } catch (err) {
        if (isMounted) setAllowed(false);
      }
    };
    checkAuth();
    return () => {
      isMounted = false;
    };
  }, []);

  if (allowed === null) return null;
  return allowed ? children : <Navigate to="/admin/login" />;
};

export default PrivateRoute;
